/** 菜单 */
export default {
    home: "首頁",
    systemMonitoring: "系統監控",
    systemTools: "系統工具", // 系统工具
    platformManage: "頻臺管理", // 平台管理
    workbench: "工作臺", // 工作台
    organization: "組織架構", // 组织架构
    entityManage: "實體管理",
    enterpriseEquipment: "企業設備", // 企业设备
    systemManage: "系統管理", // 系统管理
        region: "行政区域", // 行政区域
        userManage: "賬號管理", // 用户管理
        roleManage: "角色管理", // 角色管理
        deptManage: "部門管理", // 部门管理
        postManage: "崗位管理", // 岗位管理
        dictManage: "字典管理", // 字典管理
        counterManage: "計數器管理", // 计数器管理
        notice: "通知公告", // 通知公告
        i18nConfig: "国际化配置", // 国际化配置
    financeManage: "財務管理", // 财务管理
        applicationInfo: "應用信息", // 引用信息
        merchantInfo: "商戶信息", // 商户信息
        payChannel: "支付渠道", // 支付渠道
        payPackage: "支付套餐", // 支付套餐
        payNotice: "支付通知", // 支付通知
        merchantNotice: "商戶通知", // 商户通知
        payOrder: "支付訂單", // 支付订单
        payOrderExtend: "支付訂單擴展", // 支付订单扩展
        refundOrder: "退款訂單", // 退款订单
    dataCorrection: "數據修正", // 数据修正
        equipmentData: "設備傳輸數據", // 设备传输数据
        minuteDimension: "五分鐘維度", // 五分钟维度
        hourDimension: "小時維度", // 小时维度
        hourShadowDimension: "小時影子維度", // 小时影子维度
        dayDimension: "天維度", // 天维度
    passengerFlow: "客流管理", // 客流管理
        screenSetting: "大屏设置", // 大屏设置
        passagewayManage: "出入口管理", // 出入口管理
        faceCaptureData: "人臉抓拍數據", // 人脸抓拍数据
    logManage: "日志管理", // 日志管理
        operateLog: "操作日志", // 操作日志
        loginLog: '登錄日志', // 登录日志
    developerCentre: "開發者", // 开发者
}